import React, { useEffect, useState, useContext } from 'react';
import Layout from 'components/sales/layout/layout';
import localization from 'assets/localization/localization';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import CardSection from 'components/sales/cardSection/cardSection';
import DivLayout from 'components/sales/divLayout/divLayout';
import Config from "services/config/config";
import axios from "services/interceptor/Interceptor";
import { toast } from 'react-toastify';
import TableSection from "components/sales/tableSection/tableSection";
import './tag.css';

const TagSearchByVehicleNo = ({
  tagSearchByVehicleNo,
  tagInfo,
  auditLogs,
  tagAudit,
  history
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [isLoading, setIsLoading] = useState(false);
  const [searchTagByVehicleNo, setSearchTagByVehicleNo] = useState('');
  const [listData, setListData] = useState();
  const [pageCount, setPageCount] = useState(0);
  const [activityListData, setActivityListData] = useState();
  const [activityPageCount, setActivityPageCount] = useState(0);

  const headers = [
    "Id",
    "Project Id",
    "Audit Type",
    "Remark",
    "Created"
    
  ];

  useEffect(() => {
    const tableData = [
      "audit_id",
      "project_id",
      "audit_type",
      "remarks",
      "created"
    ];
    
    if (tagAudit !== undefined && tagAudit?.resultSets) {
      const data = tagAudit.resultSets.map((element) =>
        Object.assign(
          {},
          ...tableData.map((key) => ({ [key]: element[key] })),
          {
            
          }
        )
      );
      data && setListData(data);
      setPageCount(Math.ceil(tagAudit.total / tagAudit.per_page));
    }
  }, [tagAudit]);

  const onPageChange = async (val) => {
    // const payload = {
    //   'tag_id':searchTag
    //  }
    // setIsLoading(true);
    // const auditResponse = await auditLogs({"search":payload},searchTag,val.selected + 1);
    //   if(auditResponse && auditResponse?.data == null) {
    //     console.log('audit data not found');
    //   }
    //   setIsLoading(false);
  };
  //console.log('PAGE::TAG SEARCH');

  const handleInputChange = (e) =>{
    setSearchTagByVehicleNo(e.target.value);
  };
  
  const applySearchKey = async () => {
    if(searchTagByVehicleNo != '') {
      setIsLoading(true);
      const response = await tagSearchByVehicleNo(searchTagByVehicleNo);
      if(response && response?.data == null) {
        setIsLoading(false);
        toast.info('Tag not found.');
        return false;
      }
      //console.log('hhh >> ', response?.data);
      if(response?.data?.tag_id_list?.length > 0) {
        const tagList = response?.data?.tag_id_list;
        const payload = {
          'tag_id_list':tagList
        }
        const auditResponse = await auditLogs({"filters":payload},searchTagByVehicleNo,1);
        if(auditResponse && auditResponse?.data == null) {
          console.log('audit data not found')
        }
      }
      setIsLoading(false);
    } else {
      toast.error('Please fill search tag field.');
    }
  };
  console.log('tag-info >>> ' , tagInfo?.data?.details.length);
  return (
    <Layout
      title={localization.searchByVehicleNumbers}
      isLoading={isLoading}
      isGoback
    >
    <div className="content">
    <div className="col-md-12 mb-4">
     <div className="border border-primary rounded-10  searchBox" >
      <div className="input-group">
        <input type="search" className="form-control rounded borderColorBox" onChange={e => handleInputChange(e)} placeholder="Search Vehicle Number" aria-label="Search" aria-describedby="search-addon" />
        <button type="button" className="btn btn-outline-primary btn-primary colorBox borderColorBox" onClick={applySearchKey}>
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-search" viewBox="0 0 16 16">
        <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/>
        </svg></button>
      </div>
    </div>
    </div>  
    {tagInfo && tagInfo?.data?.details != undefined && tagInfo?.data?.details > 0 && tagInfo?.data?.details.slice(0,1).map((item,key) => {
     return (
      <CardSection title={localization.tagDetails}>
      <div className="details-listing">
          <DivLayout
              heading={`Tag Id`}
              data={item['tag_id']}
          />
          <DivLayout
              heading={`Tag Type`}
              data={item['tag_type']}
          />
          <DivLayout
              heading={`User Name`}
              data={item['name']}
          />
          <DivLayout
              heading={`Contact No.`}
              data={item['phone_number']}
          />
          <DivLayout
              heading={`Email`}
              data={item['email_id']}
          />
          <DivLayout
              heading={`Vehicle Number`}
              data={item['vehicle_number']}
          />
          <DivLayout
              heading={`Vehicle Type`}
              data={item['wheel_count']}
          />
          <DivLayout
              heading={`Status`}
              data={item['active'] == 1 ? 'Active' : item['active'] == 0 ? 'In Active' : 'N/A'}
          />
          <DivLayout
              heading={`Last Checkin`}
              data={
                item['activity']['check_in']
                  ? item['activity']['check_in']
                  : `No`
              }
            />
            <DivLayout
              heading={`Last Checkout`}
              data={
                item['activity']['check_out']
                  ? item['activity']['check_out']
                  : `No`
              }
            />
            <DivLayout
              heading={`Last Activity Project Id`}
              data={
                item['activity']['project_id']
                  ? item['activity']['project_id']
                  : `No`
              }
            />
            <DivLayout
              heading={`Last Activity Project Name`}
              data={
                item['activity']['project_name']
                  ? item['activity']['project_name']
                  : `No`
              }
            />
            
      </div>          
      </CardSection>
    )
    })}
    {tagInfo && tagInfo?.data?.details != undefined && tagInfo?.data?.details?.length > 0 && tagInfo?.data?.details.map((item,key) => {
     return (
      <CardSection title={localization.projectVehicleDetails}>
      <div className="details-listing">
          
          <DivLayout
              heading={`Project Id`}
              data={item['project_id']}
          />
          <DivLayout
              heading={`Project Name`}
              data={item['project_name']}
          />
         <DivLayout
                  heading={`Company Name`}
                  data={
                    item['vehicleData']['company_name']
                      ? item['vehicleData']['company_name']
                      : `-`
                  }
                />
          
          <DivLayout
              heading={`Project Type`}
              data={item['project_type']}
          />
          <DivLayout
              heading={`Flat Count`}
              data={item['flat_count']}
          />
          <DivLayout
              heading={`Vehicle Id`}
              data={item['vehicle_id']}
          />
          <DivLayout
              heading={`Vehicle Number`}
              data={item['vehicle_number']}
          />
          <DivLayout
              heading={`Status`}
              data={item['tag_status'] == 1 ? 'Active' : item['tag_status'] == 0 ? 'In Active' : 'N/A'}
          />
          {console.log('??> >>? ' + item['vehicleData']['registered_on_app'])}
          <DivLayout
                  heading={`Register On App`}
                  data={
                    item['vehicleData']['registered_on_app']
                      ? `Yes`
                      : `No`
                  }
                />
          <DivLayout
                  heading={`Fastag Mapping`}
                  data={
                    item['vehicleData']['fastag_mapping_status']
                      ? item['vehicleData']['fastag_mapping_status']
                      : `No`
                  }
                />
            <DivLayout
              heading={`Sync Status`}
              data={
                item['vehicleData']['sync_status']
                  ? item['vehicleData']['sync_status']
                  : `No`
              }
            />


      </div>          
      </CardSection>
    )
    })}
    
    <CardSection title={localization.tagAuditLog}>
     <div className='col-md-12'>
      <TableSection
          data={listData}
          isId={false}
          headers={headers}
          pageCount={pageCount}
          srNo={tagAudit?.from}
          onPageChange={onPageChange}

        />
        </div>
    </CardSection>
    </div>
    </Layout>
  );
};

export default TagSearchByVehicleNo;
